module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-04.bee1a86a.jpg";